import React, { useCallback, useRef, useState } from 'react';
import CRMModal from './CRMModal';
import CRMRequestContext from './CRMRequestContext';
import ProjectVendorPicker from '../project/ProjectVendorPicker';
import { outreachApi, errorText } from '../../utils/crmOutreach';
import '../../styles/projectOutreach.css';

export default function AddFromCRMModal({ workspace, list, onClose, onDone }) {
    const [selection, setSelection] = useState([]), [busy, setBusy] = useState(false), [error, setError] = useState('');
    const submitting = useRef(false);
    const loadCandidates = useCallback(async ({ page, limit, search, signal }) => {
        const result = await outreachApi.search(workspace, list.id, search, { page, limit, signal });
        return { ...result, records: result.records.map(row => ({ ...row, selected: row.inList })) };
    }, [workspace, list.id]);
    const add = async event => {
        event.preventDefault();
        if (submitting.current || !selection.length) return;
        submitting.current = true; setBusy(true); setError('');
        try { const result = await outreachApi.addMembers(workspace, list.id, selection); onDone(result); }
        catch (problem) { setError(errorText(problem)); submitting.current = false; setBusy(false); }
    };
    return <CRMRequestContext.Provider value={busy}>
        <CRMModal title={`Add vendors to ${list.name}`} subtitle={`${workspace === 'test' ? 'Test' : 'Live'} workspace · Companies and their contacts from CRM`} onClose={onClose} wide className="outreach-vendor-modal" eyebrow="CRM › OUTREACH">
            <form className="crm-form po-vendor-modal" onSubmit={add}>
                <div className="crm-form-scroll">
                    {error && <p className="crm-error" role="alert">{error}</p>}
                    <ProjectVendorPicker workspace={workspace} onSelection={setSelection} busy={busy} loadCandidates={loadCandidates} existingLabel="Already in list" lockExistingCompanies maxCompanies={500} maxContacts={2000} hint="Browse companies and select their contacts across pages. The first selected contact with an email becomes this company's campaign recipient. Select just the company to use its default contact." />
                </div>
                <footer className="crm-modal-foot"><span>{workspace === 'test' ? 'Test' : 'Live'} workspace</span><div><button className="crm-button" type="button" disabled={busy} onClick={onClose}>Cancel</button><button className="crm-button crm-primary" type="submit" disabled={busy || !selection.length}>{busy ? 'Adding…' : `Add selected${selection.length ? ` (${selection.length})` : ''}`}</button></div></footer>
            </form>
        </CRMModal>
    </CRMRequestContext.Provider>;
}
